import { observer } from 'mobx-react-lite'
import { Error, PhoneWithLabelInput, Typography } from 'shared/ui'
import { type SecurityStore } from 'pages/settings/pages/personal/pages/account/pages/security'

type IPhoneModalProps = {
  store: SecurityStore
}

export const PhoneModal = observer(({ store }: IPhoneModalProps) => {
  const { phoneInputStore, errorsMap, removeError, loading } = store
  const phoneError = errorsMap.get('phone_number')

  return (
    <>
      <Typography
        variant='body-md-medium'
        ariaLabel='Add phone number subtitle'
        tag={'div'}
        marginTop={4}
      >
        Add your mobile phone number
      </Typography>
      <Typography
        variant='body-md-regular'
        color='var(--content-primary-tertiary)'
        ariaLabel='Add phone number description'
        tag={'div'}
        marginTop={4}
        marginBottom={24}
      >
        Enter your mobile phone number to receive a verification code.
      </Typography>
      <PhoneWithLabelInput
        item={phoneInputStore.country}
        items={phoneInputStore.countries}
        number={phoneInputStore.number}
        loading={loading}
        numberError={phoneInputStore.numberError}
        isValidNumber={phoneInputStore.isValidNumber}
        numberRequestError={phoneInputStore.numberRequestError}
        setNumber={(value) => {
          phoneInputStore.setNumber(value)
          removeError('phone_number')
        }}
        setCountry={phoneInputStore.setCountry}
        triggerNumberValidation={phoneInputStore.triggerNumberValidation}
        hideLabel
        disabled={loading}
      />
      <Error type={'text'} error={phoneError} />
    </>
  )
})
